import React, { useEffect, useState } from 'react';
import { UsersIcon } from 'lucide-react';
export function LiveVisitorCounter() {
  const [visitors, setVisitors] = useState(49);
  useEffect(() => {
    const interval = setInterval(() => {
      setVisitors(prev => {
        const change = Math.floor(Math.random() * 11) - 5; // -5 to +5
        let newCount = prev + change;
        if (newCount < 40) newCount = 40 + Math.floor(Math.random() * 5);
        if (newCount > 60) newCount = 60 - Math.floor(Math.random() * 5);
        return newCount;
      });
    }, 8000 + Math.random() * 4000); // Every 8-12 seconds
    return () => clearInterval(interval);
  }, []);
  return <div className="flex items-center text-sm font-medium text-brand-400 bg-brand-950/50 border border-brand-800/50 py-1.5 px-4 rounded-full w-fit shadow-[0_0_15px_rgba(20,184,166,0.15)]" data-id="element-99">
      <div className="relative flex h-2 w-2 mr-3" data-id="element-100">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-400 opacity-75" data-id="element-101"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-500" data-id="element-102"></span>
      </div>
      <UsersIcon className="h-4 w-4 mr-2" data-id="element-103" />
      <span data-id="element-104">{visitors} personas viendo esta página ahora mismo</span>
    </div>;
}